import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { PreferenceSetEntity } from './preference-set.entity';
import { PreferenceEntity } from './preference.entity';
import { TeamEntity } from './team.entity';

@Index('fk__preference__id', ['fkPreferenceId'], {})
@Index('fk__preference_set__id_default', ['fkPreferenceSetIdDefault'], {})
@Index('fk_team__id', ['fkTeamId'], {})
@Entity('team_preference')
export class TeamPreferenceEntity extends BaseEntity {
	@Column('int', { name: 'fk_team__id', unsigned: true })
	public fkTeamId!: number;

	@Column('int', { name: 'fk__preference__id', unsigned: true })
	public fkPreferenceId!: number;

	@Column('int', {
		name: 'fk__preference_set__id_default',
		nullable: true,
		unsigned: true,
	})
	public fkPreferenceSetIdDefault!: number | null;

	@ManyToOne(() => TeamEntity, (team) => team.teamPreferences, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_team__id', referencedColumnName: 'id' }])
	public fkTeam!: TeamEntity;

	@ManyToOne(
		() => PreferenceEntity,
		(preference) => preference.teamPreferences,
		{
			onDelete: 'NO ACTION',
			onUpdate: 'NO ACTION',
		},
	)
	@JoinColumn([{ name: 'fk__preference__id', referencedColumnName: 'id' }])
	public fkPreference!: PreferenceEntity;

	@ManyToOne(
		() => PreferenceSetEntity,
		(preferenceSet) => preferenceSet.teamPreferences,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: 'fk__preference_set__id_default', referencedColumnName: 'id' },
	])
	public fkPreferenceSetIdDefault2!: PreferenceSetEntity;
}
